export default "__VITE_ASSET__003e3b0a__"